import React from 'react';
import { Col, Row } from 'reactstrap';

function NotificationsSection({ title, children }) {
  return (
    <Col>
      <Row className="settings__notification-section-header align-items-center flex-nowrap">
        <Col>{title}</Col>
        <Col xs="auto" className="settings__notification-type">
          PUSH
        </Col>
        <Col xs="auto" className="settings__notification-type email-type">
          EMAIL
        </Col>
      </Row>
      {children}
    </Col>
  );
}

export default NotificationsSection;
